/**
 * Remix icons wrapped for Backstage SidebarItem (expects IconComponent).
 */
import type { ComponentType, SVGProps } from 'react';
import {
  RiAddCircleLine,
  RiBookOpenLine,
  RiChat3Line,
  RiHome4Line,
  RiImageLine,
  RiMenuLine,
  RiSearchLine,
  RiTeamLine,
} from '@remixicon/react';

type IconProps = SVGProps<SVGSVGElement>;

const icon = (Icon: ComponentType<IconProps>) => (props: IconProps) =>
  <Icon size={20} {...props} />;

export const HomeIcon = icon(RiHome4Line);
export const ImageIcon = icon(RiImageLine);
export const CreateComponentIcon = icon(RiAddCircleLine);
export const ChatIcon = icon(RiChat3Line);
export const MenuIcon = icon(RiMenuLine);
export const SearchIcon = icon(RiSearchLine);
export const GroupIcon = icon(RiTeamLine);
export const DocsIcon = icon(RiBookOpenLine);
